"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 08 2018
 */

var FollowOneSelected_1 = require("../../model/strategy/FollowOneSelected");

var NotCheaperThan_1 = require("../../model/strategy/NotCheaperThan");

var NotMoreExpensiveThan_1 = require("../../model/strategy/NotMoreExpensiveThan");

var StrategyTypeEnum_1 = require("../../model/strategy/StrategyTypeEnum");
/**
 * SingleTargetStrategyBuilder
 *
 * @author RV
 */


var SingleTargetStrategyBuilder =
/*#__PURE__*/
function () {
  /**
   * @param type of strategy
   * @param competitorId
   */
  function SingleTargetStrategyBuilder(type, competitorId) {
    _classCallCheck(this, SingleTargetStrategyBuilder);

    this.type = type;
    this.competitorId = competitorId;
  }
  /**
   * @returns builded {@link SingleTargetStrategy}.
   */


  _createClass(SingleTargetStrategyBuilder, [{
    key: "build",
    value: function build() {
      switch (this.type) {
        case StrategyTypeEnum_1.StrategyTypeEnum.FollowOneSelected:
          {
            return new FollowOneSelected_1.FollowOneSelected(this.competitorId);
          }

        case StrategyTypeEnum_1.StrategyTypeEnum.NotCheaperThan:
          {
            return new NotCheaperThan_1.NotCheaperThan(this.competitorId);
          }

        case StrategyTypeEnum_1.StrategyTypeEnum.NotMoreExpensiveThan:
          {
            return new NotMoreExpensiveThan_1.NotMoreExpensiveThan(this.competitorId);
          }

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(this.type));
          }
      }
    }
  }]);

  return SingleTargetStrategyBuilder;
}();

exports.SingleTargetStrategyBuilder = SingleTargetStrategyBuilder;